var _path;

import * as React from "react";

function SvgSave(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.996 10.996l-5.992-5.992A3.428 3.428 0 0026.58 4H7.429A3.429 3.429 0 004 7.429V32.57A3.429 3.429 0 007.429 36H32.57A3.429 3.429 0 0036 32.571v-19.15c0-.91-.361-1.782-1.004-2.425zM24.57 6.286v6.857H10.857V6.286h13.714zm9.143 26.285c0 .63-.512 1.143-1.143 1.143H7.43c-.63 0-1.143-.512-1.143-1.143V7.43c0-.63.512-1.143 1.143-1.143h1.14v7.428c0 .947.768 1.715 1.715 1.715h14.857c.947 0 1.714-.768 1.714-1.715V6.321c.201.05.385.153.531.3l5.992 5.991a1.137 1.137 0 01.334.808v19.151zM20 18.286a6.293 6.293 0 00-6.286 6.285A6.293 6.293 0 0020 30.857a6.293 6.293 0 006.286-6.286A6.293 6.293 0 0020 18.286zm0 10.285c-2.206 0-4-1.794-4-4 0-2.205 1.794-4 4-4s4 1.795 4 4c0 2.206-1.794 4-4 4z"
  })));
}

export default SvgSave;